<script setup lang="ts">
import { computed, onMounted, onUnmounted, type PropType, ref } from 'vue'
import { type NotificationType, useNotification, VIcons } from '@/shared/ui'

const props = defineProps({
  notification: {
    type: Object as PropType<NotificationType>,
    required: true,
  },
})

const { remove } = useNotification()
const timeout = ref(0)

const icon = computed(() => {
  switch (props.notification.type) {
    case 'success':
      return 'check_circle'
    case 'error':
      return 'error'
    case 'warning':
      return 'warning'
    default:
      return 'check_circle'
  }
})

/* Автоматическое удаление оповещений */
onMounted(() => {
  const delay = props.notification.delay || 4000

  timeout.value = setTimeout(() => {
    remove(props.notification.id || '')
  }, delay)
})

onUnmounted(() => {
  clearTimeout(timeout.value)
})
</script>

<template>
  <div class="v-notification__item">
    <VAlert
      border="start"
      :title="notification.title"
      density="compact"
      :type="notification.type || 'success'"
    >
      {{ notification.message }}

      <template #prepend>
        <VIcons :type="icon" />
      </template>

      <template #close>
        <VIcons type="close" class="v-notification__close" @click="remove(notification.id || '')" />
      </template>
    </VAlert>
  </div>
</template>
